export const RULES_TEXT = `Be respectful and appropriate. Harassment, hate speech, racism, slander, extremism, NSFW content, violent content, or harmful content is not allowed.

No religious or political discussions.

Do not share personal information about others.

Account holders are responsible for all actions taken on their account.

No sabotage, cheating, griefing.

Only one account is allowed per person. (Unless agreed with a moderator beforehand for a youtube video or other legitimate reasons.)

No illegal or criminal activities. For clarity, this refers to Swedish law: https://svenskforfattningssamling.se/

No spam or trolling. Use channels for their intended purpose.

Do not spread misinformation.

Do not sell Nord accounts.

Do not start a support ticket through Discord DM to an Admin, Moderator or NordHelper. Use the designated help and support channels instead.

If an Admin or Moderator finds that an infraction has taken place, they have the right to take action for any rules or community standards that may have been violated.

Cases will be evaluated individually to help ensure fair, safe, and reasonable decisions by the Admin and Moderation team.`;
